import(/* webpackMode: "eager" */ "E:\\AjayWork\\Orange_Tiger_Nextjs\\src\\app\\[brandSlug]\\[propertySlug]\\[citySlug]\\events\\page.js");
